export default __webpack_public_path__ + "static/media/introducingSeller.a4a100f6.svg";